<template>
  <div v-cloak id="sale-product">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('GenericProduct'), sort: 'GenericProduct' },
            { title: $t('BrandName'), sort: 'BrandName' },
            { title: $t('WarrantyName'), sort: 'WarrantyName' },
            { title: $t('ColorName'), sort: 'ColorName' },
            { title: $t('ItemCode'), sort: 'ItemCode' },
            { title: $t('ModelNumber'), sort: 'ModelNumber' },
            { title: $t('Price'), sort: 'Price' },
            { title: $t('↓'), sort: '↓' },
            { title: $t('↑'), sort: '↑' },
            { title: $t('QuotaCount'), sort: 'QuotaCount' },
            { title: $t('Status'), sort: 'Status' }
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 22%" :title="row.productName">
              {{ row.productName | truncate(75) }}
            </td>
            <td style="width: 8%">{{ row.genericProductName }}</td>
            <td style="width: 8%">{{ row.brandName }}</td>
            <td style="width: 8%">{{ row.warrantyName }}</td>
            <td style="width: 8%">{{ row.colorName }}</td>
            <td style="width: 8%">{{ row.itemCode }}</td>
            <td style="width: 8%">
              <span v-if="row.modelNumber">{{ row.modelNumber }}</span>
              <span v-else>-</span>
            </td>
            <td style="width: 8%">
              <span v-if="row.price != null">
                {{ Number(row.price).toLocaleString() }} ریال</span
              >
              <span v-else>-</span>
              <span v-if="row.priceBoundaryStatus !== 'Unchanged'"
                ><span class="red-notify"></span
              ></span>
              <span v-if="row.priceBoundaryStatus == 'Unchanged'"
                ><span class="green-notify"></span
              ></span>
            </td>
            <td style="width: 4%">{{ row.minOrderQuantity }}</td>
            <td style="width: 4%">{{ row.maxOrderQuantity }}</td>
            <td style="width: 4%">
              <span v-if="row.quotaCount">
                {{ row.quotaCount }}
              </span>
              <span v-else> - </span>
            </td>
            <td style="width: 7%">
              <span v-if="row.status == 0">{{ $t("ReadyForSale") }}</span>
              <span v-if="row.status == 1">{{ $t("ComingSoon") }}</span>
              <span v-if="row.status == 2">{{ $t("StopSale") }}</span>
            </td>
          </template>
        </data-grid>
      </div>
    </div>

    <div v-show="showUpdateLoading">
      <div id="update-loading"></div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_sale.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "saleManagement_MyContracts_Management_products",

  components: {
    DataGrid
  },
  data() {
    this.$route.params.id;
    return {
      AssignProductPopup: false,
      modalModel: {},
      ProductPricesPopup: false,
      pricesModel: {},
      showUpdateLoading: false,
      EditProductPopup: false,
      productModel: {},
      showFilters: false,
      contractId: this.$route.params.id,
      gridDataSource: {
        type: "app",
        service:
          "/Sales/api/SaleProductManagerQuery/" +
          this.$route.params.id +
          "/product-info/"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  },
  methods: {
    ...mapActions({
      UpdatePriceMethod: "sale/updatePrice",
      exportProductsExcel: "excel/exportContractProductsQuery"
    }),
    onfinish() {
      this.AssignProductPopup = false;
      this.$refs.grid.renderGrid();
    },
    assignProduct() {
      this.modalModel = {};
      this.AssignProductPopup = true;
    },
    pricePopup(model) {
      this.ProductPricesPopup = true;
      this.pricesModel = {
        basePrice: model.basePrice,
        contractBasePrice: model.contractBasePrice,
        contractPrice: model.contractPrice,
        priceWithoutBoundary: model.priceWithoutBoundary,
        price: model.price,
        priceBoundaryStatus: model.priceBoundaryStatus,
        sumOfDiscountsAmount: model.sumOfDiscountsAmount,
        deductionAndIncreaseAmount: model.deductionAndIncreaseAmount,
        totalTax: model.totalTax,
        baseConsumerPrice: model.baseConsumerPrice
      };
    },
    updatePrice() {
      this.showUpdateLoading = true;
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#update-loading",
        scale: 1,
        type: "sound"
      });
      this.UpdatePriceMethod(this.$route.params.id).then(() => {
        setTimeout(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "قیمت محصولات قرارداد با موفقیت به روزرسانی شد!",
            showConfirmButton: false,
            timer: 2000
          });
          this.$refs.grid.renderGrid();
        }, 3000);
      });
      setTimeout(() => {
        this.$vs.loading.close("#update-loading > .con-vs-loading");
        this.showUpdateLoading = false;
      }, 3000);
    },
    edit(model) {
      this.productModel = {
        contractId: this.$route.params.id,
        productId: model.productId,
        minOrderQuantity: model.minOrderQuantity,
        maxOrderQuantity: model.maxOrderQuantity,
        status: model.status
      };
      this.EditProductPopup = true;
    },
    onfinisheEdit() {
      this.EditProductPopup = false;
      this.$refs.grid.renderGrid();
    },
    onfinisheViewPrices() {
      this.ProductPricesPopup = false;
    },
    downloadFile() {
      this.exportProductsExcel(this.contractId);
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = { keyword: "" };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    }
  }
};
</script>
